export default {
  ui: {
    inputRepositoryURL: 'Input GitHub repository URL...'
  }
}
